import type { ChakraStylesConfig, GroupBase } from 'chakra-react-select';

type EntitySearchSelectStyleOptions = {
  /**
   * LandingSearch has a left-side entity dropdown button (a "left addon"),
   * so the select control has its left border-radius removed to visually connect.
   *
   * Most other usages should keep the default radius.
   */
  hasLeftAddon?: boolean;
};

export const createEntitySearchSelectChakraStyles = <TOption>({
  hasLeftAddon = false,
}: EntitySearchSelectStyleOptions = {}): ChakraStylesConfig<
  TOption,
  true,
  GroupBase<TOption>
> => ({
  container: (provided) => ({
    ...provided,
    w: '100%',
    color: 'text.primary',
  }),
  control: (provided) => ({
    ...provided,
    ...(hasLeftAddon
      ? {
          borderTopLeftRadius: 0,
          borderBottomLeftRadius: 0,
        }
      : {}),
    h: '100%',
  }),
  multiValue: (provided) => ({
    ...provided,
    backgroundColor: 'rgb(236, 249, 254)',
    border: `1px solid rgb(162, 223, 249)`,
    borderRadius: '4px',
    color: '#ffffff',
  }),
  multiValueLabel: (provided) => ({
    ...provided,
    color: 'text.primary',
  }),
  multiValueRemove: (provided) => ({
    ...provided,
    color: 'text.primary',
  }),
  noOptionsMessage: (provided) => ({
    ...provided,
    textAlign: 'left',
    pl: 4,
    fontSize: 'md',
  }),
  menuList: (provided) => ({
    ...provided,
    maxH: '200px',
  }),
});
